<template>
  <div class="page-background">
    <main-header :title="'Add Family Member'" :color="'white'" ></main-header>
    <div class="mobile-edit-form">
      <v-form  v-model.trim="valid" ref="form">
        <div>
          <h3 class="from-headers">Personal Information</h3>
          <v-text-field outlined label="First Name" color="white" class="input-text" v-model="member.firstName" :rules="requiredRules"></v-text-field>
          <v-text-field outlined label="Last Name" color="white" v-model="member.lastName" :rules="requiredRules"></v-text-field>
          <v-text-field color="white" type="date" outlined label="Date of Birth" v-model="member.dob" ></v-text-field>
          <v-select color="white" :items="genders" label="Select" outlined v-model="member.gender" :rules="requiredRules"></v-select>
        </div>

        <div>
          <h3 class="from-headers">Contact</h3>
          <v-text-field type="email" outlined label="Email" color="white" v-model="member.email" :rules="emailRules"></v-text-field>
          <v-text-field type="tel" outlined label="Phone" placeholder="000-000-0000 " color="white" v-model="member.phone" :rules="requiredRules"></v-text-field>
          <v-text-field color="white" type="number" placeholder="00000" outlined label="Home Zip Code" v-model="member.zipCode" :rules="requiredRules"></v-text-field>
        </div>

        <div>
          <h3 class="from-headers">
            Insurance Information <br />
            <span class="from-sub-headers">(from your insurance card)</span>
          </h3>
          <v-text-field outlined label="Member ID" color="white" placeholder="000-000000" v-model="member.memberId" :rules="requiredRules"></v-text-field>
          <v-text-field outlined label="Group ID" placeholder="000-000000" color="white" v-model="member.groupId" :rules="requiredRules"></v-text-field>
          <v-text-field outlined label="Payer ID" placeholder="000-000000" color="white" v-model="member.payerId" :rules="requiredRules"></v-text-field>
          <v-text-field outlined label="Plan ID" placeholder="000-000000" color="white" v-model="member.planId" :rules="requiredRules"></v-text-field>

          <v-select color="white" :items="relationships" label="Select" v-model="member.subscriberRelation" outlined></v-select>
        </div>
      </v-form>


    </div>
    <div class="d-flex footer"  style="">
      <div class="col-6">
        <v-btn class="footer-btn-cancel" >Cancel</v-btn>
      </div>
      <div class="col-6">
        <v-btn color="white" class="footer-btn" @click="submit">Next</v-btn>
      </div>
    </div>
    <v-snackbar v-model="snackbar" timeout="3000">
      {{textInSnackbar}}
    </v-snackbar>
  </div>
</template>

<script>
import mainHeader from "@/components/Sections/DPCMember/Layout/mainHeader";
import api from "@/services/api";
export default {
  data() {
    return {
      valid:false,
      snackbar:false,
      textInSnackbar:'',
      relationships: ["Spouse"],
      genders: [
        {
          text: "Male",
          value: "m",
        },
        {
          text: "Female",
          value: "f",
        },
      ],
      member:{
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        email: "",
        phone: "",
        zipCode: "",
        memberId: "",
        groupId: "",
        planId: "",
        payerId: "",
        subscriberRelation:""
      },
      emailRules: [
        (v) => !!v || "This field is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
    };
  },
  components: {
    mainHeader,
  },
  methods: {
    submit(){
      this.$refs.form.validate();
      if (this.valid){
        api()
            .post(`/member/app/family/member`, this.member)
            .then((res) => {
              if (res) {
                this.$router.push('/dpc-member/account/alert/add');
              }
            })
            .catch((err) => {
              this.snackbar = true;
              this.textInSnackbar=err.response.data;
            });
      }
    }

  },
  created() {},
};
</script>
<style scoped src='./../../../../../assets/mobileStyle.css'></style>
<style scoped lang="scss">
.mobile-edit-form {
  background-color: #16407a;
  height: 100vh;
  padding: 20px;
  overflow-y: auto;
  padding-bottom: 150px !important;
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;
}

.mobile-content {
  padding: 16px 24px 0 24px;
}

.page-background{
  background-color: #001e46;
}

.from-headers {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  padding-bottom: 15px;
  color: white;
}

.from-sub-headers {
  font-family: "Quicksand";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}

.footer{
  background-color: #16407a;
  height:80px;
  position:absolute;
  bottom:0;
  width:100%;
  align-items: flex-start;
  border-top: 1px solid #C9C9C9
}
.footer-btn{
  border-radius: 23px;
  width: 134px;
}

.footer-btn-cancel{
  background-color:#16407a !important;
  border-radius: 23px;
  width: 134px;
  border: 1px solid white !important;
  color: white;
  float:right
}

::-webkit-scrollbar {
  display: none;
}


</style>
